import axiosInstance from '../axiosInterceptor/axiosInstance'
import eventCollection from '../../utils/helpers/eventHelpers/eventCollection'

const createEvent = (data) => {
  const { formData, eventType, orgId } = data
  const newData = {
    ...formData,
    eventTypeId: eventType.id,
  }
  const url = `v1/orgs/${orgId}/events/${eventCollection(eventType.code)}`

  return axiosInstance.post(url, newData)
}

export default createEvent
